import React, { useEffect } from 'react';
import loadable from 'loadable-components';
import { Helmet } from 'react-helmet';
import menuList from './menulist';
import { Switch, Route, useLocation } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { Link, Redirect } from 'react-router-dom';

import classNames from 'classnames';

import './App.css';
import './style/index.scss';
import './change.scss';

declare global {
  interface Window {
    adsbygoogle: { [key: string]: unknown }[];
  }
}

interface Props {
  className?: string;
}
function App({ className }: Props) {
  // useEffect(() => {
  //   window.location.href = 'https://awesome-ui.netlify.app';
  // }, []);

  return (
    <div className="App home-change">
      <div>
        <p>페이지 주소가 변경되었습니다.</p>
        <a
          target="_self"
          href="https://awesome-ui.netlify.app"
          className="btn-link"
        >
          실시간 검색어 보러가기
        </a>
      </div>
    </div>
  );
}

export default App;
